export default "__VITE_ASSET__KPTS0uhb__"